import React from 'react';
import {
  Typography, Alert, Box,
} from 'vindi-ds-components';

const Header = ({ headerTitle }) => (
  <Box>
    <Typography variant='h5' component='h1' style={{ marginBottom: '2em' }}>
      {headerTitle}
    </Typography>
    <Alert>
      Os produtos são recorrentes ou avulsos, podendo ser usados em planos para
      assinaturas ou em páginas de pagamento para captura externa de clientes.
    </Alert>
  </Box>
);

export default Header;
